import React, { useState } from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  HStack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { FiPlay } from 'react-icons/fi';
import { RemoteWSStatus } from '../types';

interface Props {
  onRunQuery: (sql: string) => void;
  loading: boolean;
  wsStatus: RemoteWSStatus;
  sessionActive: boolean;
}

const PLACEHOLDER = `-- Contoh:
SELECT * FROM t_harvest LIMIT 20;
UPDATE t_harvest SET status = 'done' WHERE id = 1;`;

const WRITE_PREFIXES = ['INSERT', 'UPDATE', 'DELETE'];

/** Returns the target table if this is a write to a non-t_ table, otherwise null. */
function detectNonTrxWrite(sql: string): string | null {
  const upper = sql.trim().toUpperCase();
  if (!WRITE_PREFIXES.some((p) => upper.startsWith(p))) return null;
  const m = upper.match(/(?:UPDATE|INSERT\s+INTO|DELETE\s+FROM)\s+(\w+)/);
  const table = m?.[1]?.toLowerCase() ?? '';
  return table && !table.startsWith('t_') ? table : null;
}

const SaktiRemoteQueryConsole: React.FC<Props> = ({ onRunQuery, loading, wsStatus, sessionActive }) => {
  const [sql, setSql] = useState('');
  const nonTrxTable = sql.trim() ? detectNonTrxWrite(sql) : null;

  const handleRun = () => {
    const trimmed = sql.trim();
    if (!trimmed) return;
    onRunQuery(trimmed);
  };

  return (
    <Box>
      <Textarea
        value={sql}
        onChange={(e) => setSql(e.target.value)}
        placeholder={PLACEHOLDER}
        fontFamily="mono"
        fontSize="sm"
        rows={6}
        bg="gray.900"
        color="green.300"
        borderColor="gray.700"
        _placeholder={{ color: 'gray.600' }}
        _focus={{ borderColor: 'green.500', boxShadow: 'none' }}
        resize="vertical"
        disabled={!sessionActive}
      />

      {nonTrxTable && (
        <Alert status="warning" mt={2} borderRadius="md" fontSize="xs" py={2}>
          <AlertIcon boxSize={3} />
          Tabel <strong>&nbsp;{nonTrxTable}&nbsp;</strong> bukan tabel transaksi (t_*) — operasi write mungkin ditolak perangkat.
        </Alert>
      )}

      <HStack mt={2} justify="space-between" align="center">
        {!sessionActive && (
          <Text fontSize="xs" color="orange.400">
            Tunggu perangkat Android terhubung dan disetujui
          </Text>
        )}
        <Box flex={1} />
        <Button
          leftIcon={<FiPlay />}
          colorScheme="green"
          size="sm"
          isLoading={loading}
          isDisabled={!sessionActive || !sql.trim()}
          onClick={handleRun}
        >
          Jalankan
        </Button>
      </HStack>
    </Box>
  );
};

export default SaktiRemoteQueryConsole;
